<template>
  <div class="home">
    <div class="home-content page-content">
      <div class="swiper-wrap">
        <img class="swiper-img" src="../../assets/home/home-bg-m.png" alt="">
      </div>
      <div class="info">
        <div class="info-content">
          <div class="title">
            <span>为什么选择在线办理ETC</span>
            <span color-primary>月办理人数{{ETC.MONTH_NUM}}</span>
          </div>
          <div class="line">
            <i color-primary class="iconfont etc-icon-check"></i>
            <span class="label">办理简单</span>
            <span color-999>免信用卡在线办理</span>
          </div>
          <div class="line">
            <i color-primary class="iconfont etc-icon-check"></i>
            <span class="label">全国通行</span>
            <span color-999>支持通行全国ETC车道</span>
          </div>
          <div class="line">
            <i color-primary class="iconfont etc-icon-check"></i>
            <span class="label">路费打折</span>
            <span color-999>全国高速通行95折起</span>
          </div>
        </div>
      </div>
      <!--测试服支付回调页面 {{$route.query}}-->
    </div>
    <div class="btn-wrap">
      <button class="apply-btn" cool-btn @click="showTip">申办ETC</button>
      <button class="more-btn" cool-btn-hollow @click="showTip">了解更多</button>
    </div>
  </div>
</template>

<script>
// config
import ETC from '@/config/etc.config'
// mixin
import FunMixin from '@/mixins/funMixin'

let customData = {
  cannotTip: ''
}

export default {
  name: 'payBack',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      ETC,
      appChannel: ''
    }
  },
  methods: {
    showTip() {
      this.m_showConfirm({content: customData.cannotTip}).then(() => {
        if (ETC.APP_SCHEME[this.appChannel]) {
          location.href = ETC.APP_SCHEME[this.appChannel]
        }
      })
    }
  },
  async mounted () {
    // this.m_changeHeaderBG('#52D5AD')
    const channel = this.$route.query.channel
    this.appChannel = channel
    // 首页适配
    // 在第二次进入时首页，清空记录
    if (localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD)) {
      this.$router.go(-(history.length - 1))
      return
    }
    // 若页面没有参数
    customData.cannotTip = channel ? '请前往"' + ETC.APP_EVNS_CN[channel] + '"查看详情' : '该页面无效，请在微信搜索“etc助手”小程序办理'
    this.m_showConfirm({content: customData.cannotTip}).then(() => {
      if (ETC.APP_SCHEME[this.appChannel]) {
        location.href = ETC.APP_SCHEME[this.appChannel]
      }
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.home{
  position: relative;
  @include routeViewMinH(340px);
  .swiper-wrap{
    font-size: 0;
    .swiper-img{
      height: 460px;
      width: 100%;
    }
  }
  .info{
    background-color: #8A9CA4;
    padding: 1px 30px 30px;
    margin-top: -1px;
    .info-content{
      background-color: #fff;
      border-radius: 8px;
      padding: 25px 20px 20px 40px;
      .title{
        @extend %flex-space-between;
        padding-bottom: 10px;
        span:first-child{
          font-weight: bold;
          color: #333333;
          font-size: 30px;
        }
        span:last-child{
          font-size: 24px;
        }
      }
      .line{
        @extend %flex-align-center;
        height: 54px;
        color: #333333;
        font-size: 30px;
        i{
          font-size: 26px;
          margin-right: 15px;
        }
        .label{
          margin-right: 40px;
        }
      }
    }
  }
  .btn-wrap{
    width: 100%;
    padding: 30px 40px 20px;
    .apply-btn{
      font-weight: bold;
      line-height: 110px;
      height: 110px;
    }
    .more-btn{
      height: 110px;
      line-height: 110px;
      margin-top: 40px;
    }
  }
}
</style>
